import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class getPendingService {
  public isPending: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
